import React from 'react';

import cx from 'classnames';

import Button from 'components/shared/Button';
import DropzoneDesc from 'components/shared/FileDropZone/Description/Ligth';
import FormGroup from 'components/shared/FormAdapters/FormDefault/FormGroup/Base';
import { FileText } from 'components/shared/Icon/phosphorIcons';
import { capitalize } from 'utils/common';

import styles from './index.module.css';
import { IUploadProps } from './types';

const renderDefaultText = ({ buttonActionType, contentType }: { buttonActionType: any; contentType: any }) =>
  `${capitalize(buttonActionType)} ${capitalize(contentType)}`;

function Upload({
  onOpenModal,
  allowedMimeTypes,
  contentType = 'files',
  buttonActionType = 'upload',
  maxFileSize,
  placeholder,
  isFilesEmpty,
  recommendedFileSize,
  renderButtonText = renderDefaultText,
  disabled,
}: IUploadProps) {
  return (
    <div className={styles.uploadWrapper}>
      <FormGroup>
        <DropzoneDesc
          // @ts-ignore
          allowedMimeTypes={allowedMimeTypes}
          maxFileSize={maxFileSize}
          recommendedFileSize={recommendedFileSize}
          headComponent={
            <Button
              htmlType="button"
              className={cx(styles.mainBtn, 'custom-documents-main-btn')}
              onClick={onOpenModal}
              disabled={disabled}
            >
              {renderButtonText({ buttonActionType, contentType })}
            </Button>
          }
          placeholder={placeholder}
          isFilesEmpty={isFilesEmpty}
          placeholderIcon={() => <FileText size={33} color="#616161" weight="light" />}
        />
      </FormGroup>
    </div>
  );
}

export default Upload;
